import { render } from "./FileUploadFormV2.vue?vue&type=template&id=6c5e7214&scoped=true&ts=true"
import script from "./FileUploadFormV2.vue?vue&type=script&lang=ts"
export * from "./FileUploadFormV2.vue?vue&type=script&lang=ts"

import "./FileUploadFormV2.vue?vue&type=style&index=0&id=6c5e7214&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5e7214"]])

export default __exports__